import { formatUrl } from '@/utils/request'

const SITE_TITLE = '山东省心理咨询行业协会'
const DEFAULT_SHARE_IMAGE = 'https://www.sdxlxh.cn/static/images/logo-share.jpg'
const JWEIXIN_URL = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'

let wxScriptPromise = null

function isWechat() {
  return /MicroMessenger/i.test(navigator.userAgent)
}

function loadWxScript() {
  if (window.wx) {
    return Promise.resolve(window.wx)
  }
  if (wxScriptPromise) {
    return wxScriptPromise
  }

  wxScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = JWEIXIN_URL
    script.async = true
    script.onload = () => resolve(window.wx)
    script.onerror = () => reject(new Error('微信JS-SDK加载失败'))
    document.head.appendChild(script)
  })

  return wxScriptPromise
}

function stripHtml(value) {
  return String(value || '')
    .replace(/<[^>]+>/g, '')
    .replace(/\s+/g, ' ')
    .trim()
}

function pickShareImage(source) {
  if (!source) return ''
  if (typeof source === 'string' || typeof source === 'number') return String(source)
  if (Array.isArray(source)) {
    return pickShareImage(source[0])
  }
  if (typeof source === 'object') {
    return source.url || source.src || source.path || source.cover || source.img || source.image || source.fileUrl || ''
  }
  return ''
}

function absoluteUrl(url) {
  const value = pickShareImage(url)
  if (!value) {
    return DEFAULT_SHARE_IMAGE
  }
  if (/^https?:\/\//i.test(value)) {
    return value
  }
  return `${window.location.origin}${value.startsWith('/') ? value : `/${value}`}`
}

function normalizeConfig(data) {
  if (typeof data === 'string') {
    try {
      return JSON.parse(data)
    } catch (e) {
      return {}
    }
  }
  return data || {}
}

export async function setWechatShare(options = {}) {
  if (!isWechat()) {
    return
  }

  const pageUrl = window.location.href.split('#')[0]

  try {
    const wx = await loadWxScript()
    const response = await fetch(formatUrl('user.user_third/wechatJSSDK'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams({ url: pageUrl }).toString()
    })
    if (!response.ok) {
      throw new Error(`微信分享签名接口异常：${response.status}`)
    }
    const res = await response.json()
    if (!res || res.code !== 2000) {
      throw new Error(res?.msg || '微信分享签名获取失败')
    }
    const config = normalizeConfig(res && res.data)

    wx.config({
      debug: false,
      appId: config.appId || config.app_id,
      timestamp: config.timestamp,
      nonceStr: config.nonceStr || config.noncestr,
      signature: config.signature,
      jsApiList: [
        'updateAppMessageShareData',
        'updateTimelineShareData'
      ]
    })

    wx.ready(() => {
      const title = stripHtml(options.title) || SITE_TITLE
      const desc = stripHtml(options.desc).slice(0, 120) || SITE_TITLE
      const link = options.link || pageUrl
      const imgUrl = absoluteUrl(options.imgUrl)

      wx.updateAppMessageShareData({
        title,
        desc,
        link,
        imgUrl
      })

      wx.updateTimelineShareData({
        title,
        link,
        imgUrl
      })
    })

    wx.error((err) => {
      console.error('微信分享配置失败', err)
    })
  } catch (e) {
    console.error('微信分享初始化失败', e)
  }
}

export function setDefaultWechatShare() {
  return setWechatShare({
    title: SITE_TITLE,
    desc: '山东省心理咨询行业协会官方网站',
    imgUrl: DEFAULT_SHARE_IMAGE,
    link: window.location.href.split('#')[0]
  })
}

export {
  DEFAULT_SHARE_IMAGE
}
